module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "base-tree-item",
    class: {
      'is-has-child': _vm.data[_vm.props.children] && _vm.data[_vm.props.children].length,
        'is-hide': !_vm.idei,
        'is-online': _vm.data.online + '' === '1'
    },
    attrs: {
      "item-id": _vm.generateId
    }
  }, [_c('div', {
    staticClass: "tree-item-label-wrap",
    style: ({
      paddingLeft: ((_vm.level*12) + "px")
    })
  }, [_c('span', {
    staticClass: "tree-item-arrow tree-item-switch"
  }), _vm._v(" "), _c('span', {
    staticClass: "tree-item-label tree-item-switch",
    class: {
      'line': _vm.data[_vm.props.tag] === 'line',
        'vehicle': _vm.data[_vm.props.tag] === 'vehicle',
        'channel': _vm.data[_vm.props.tag] === 'channel'
    }
  }, [_vm._v(_vm._s(_vm.data[_vm.props.label]))])]), _vm._v(" "), _c('div', {
    staticClass: "tree-item-child"
  }, [_vm._l((_vm.data.children), function(child, index) {
    return (_vm.data.children && _vm.data.children.length) ? [_c('base-tree-item', {
      key: index,
      attrs: {
        "data": child,
        "level": _vm.level + 1,
        "props": _vm.props,
        "generate-id-rules": _vm.generateIdRules,
        "is-default-expand": _vm.isDefaultExpand,
        "index": index
      }
    })] : _vm._e()
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cf149c0!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/base-tree/src/composition/base-tree-item.vue
// module id = 75
// module chunks = 0